import {
  useFiltersDispatch,
  useFiltersState,
} from 'features/filters/Filters.context';

import type { FiltersModalProps as UseFiltersModalArgs } from 'features/filters/components/FiltersModal/FiltersModal.typed';

import { formatNumber } from 'helpers/formatting';

const useFiltersModal = (args: Pick<UseFiltersModalArgs, 'adCount'>) => {
  const { adCount } = args;

  const { isFilterModalOpen: isOpen } = useFiltersState();
  const { setIsFilterModalOpen } = useFiltersDispatch();

  const askToClose = () => setIsFilterModalOpen(false);

  const onClickResultsButton = () => {
    window.scroll({ top: 0 });
    setIsFilterModalOpen(false);
  };

  const resultOrResults = `result${adCount === 1 ? '' : 's'}`;

  const resultsButtonText = `Show ${formatNumber(adCount)} ${resultOrResults}`;

  return {
    isOpen,
    resultsButtonText,
    askToClose,
    onClickResultsButton,
  };
};

export { useFiltersModal };
